/* @pareto-engineering/generator-front 1.0.12 */
import {
  // urljoin as _u,
  loadable,
} from 'utils'

import MODULE_URLS from './urls'

export default [
  {
    path:[
      MODULE_URLS.LIST,
      MODULE_URLS.LIST_PAGINATED,
      MODULE_URLS.LIST_CATEGORY,
      MODULE_URLS.LIST_CATEGORY_PAGINATED,
    ],
    component:loadable(() => import(/* webpackChunkName: `app.blog` */ './pages/List')),
    exact    :true,
  },
  {
    path     :MODULE_URLS.SINGLE,
    component:loadable(() => import(/* webpackChunkName: `app.blog` */ './pages/Single')),
    exact    :true,
  },
]
